import React from 'react';
import Image, { ImageProps } from './Image';

export interface ThumbnailProps extends ImageProps {
  size?: number;
}

const Thumbnail = React.forwardRef<HTMLImageElement, ThumbnailProps>(({
  size = 80,
  rounded = true,
  objectFit = 'cover',
  style,
  ...props
}, ref) => (
  <Image
    ref={ref}
    rounded={rounded}
    objectFit={objectFit}
    style={{
      width: `${size}px`,
      height: `${size}px`,
      ...style,
    }}
    {...props}
  />
));

Thumbnail.displayName = 'Thumbnail';

export default Thumbnail;

